import { DefaultRequestParams } from '../GeneralTypes';
import { paths, components } from './generated-schemas/productServiceSchema';

export type ProductServicePaths = paths;

export type EnrichedProductParams = Omit<
  ProductServicePaths['/enrichedproduct/productcode']['get']['parameters']['query'],
  keyof DefaultRequestParams | 'mainWebShop'
>;

type ProductFeaturesComparison =
  ProductServicePaths['/cache/product/features/comparison/{market}/{mainWebShopId}/{productId}']['get'];

export type ProductFeaturesComparisonPathVariables = Omit<
  ProductFeaturesComparison['parameters']['path'],
  keyof DefaultRequestParams
>;

export type ProductFeaturesComparisonResponse =
  ProductFeaturesComparison['responses']['200']['content']['application/json'];

export type ProductFeaturesComparisonFeature = components['schemas']['ComparisonFeature'];
